import { render } from "./SmartdataLanding.vue?vue&type=template&id=cf0ef304&scoped=true"
import script from "./SmartdataLanding.vue?vue&type=script&lang=js"
export * from "./SmartdataLanding.vue?vue&type=script&lang=js"

import "./SmartdataLanding.vue?vue&type=style&index=0&id=cf0ef304&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0ef304"]])

export default __exports__